// extracted by mini-css-extract-plugin
export default {"grid":"UniversityCards_grid__bGz8l"};